/* __next_internal_client_entry_do_not_use__ StatusBadge auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Row, VerticalLine } from "@faire/web--source/slate/Layout";
import { TypographyStyles } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
import { highVisSlateComponent, HIGH_VIS_FILTER } from "../utils/highVisSlateComponent";
export var StatusBadge = function(props) {
    var backgroundColor = props.backgroundColor, borderColor = props.borderColor, borderRadius = props.borderRadius, content = props.content, _props_contentColor = props.contentColor, contentColor = _props_contentColor === void 0 ? Core.text.default : _props_contentColor, prefix = props.prefix;
    var border = borderColor ? "1px solid ".concat(borderColor) : "none";
    var _props_dividerColor, _ref;
    var dividerColor = (_ref = (_props_dividerColor = props.dividerColor) !== null && _props_dividerColor !== void 0 ? _props_dividerColor : contentColor) !== null && _ref !== void 0 ? _ref : Core.border.muted;
    return /*#__PURE__*/ _jsxs(StatusBadgeWrapper, {
        $backgroundColor: backgroundColor,
        $border: border,
        $borderRadius: borderRadius,
        $contentColor: contentColor,
        "data-test-id": props["data-test-id"],
        className: props.className,
        children: [
            prefix ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    prefix,
                    /*#__PURE__*/ _jsx(VerticalLine, {
                        $color: dividerColor,
                        $margin: "0 6px",
                        $height: "12px"
                    })
                ]
            }) : null,
            content
        ]
    });
};
var StatusBadgeWrapper = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-388b069b-0"
})([
    "",
    ";background-color:",
    ";block-size:24px;border:",
    ";border-radius:",
    ";color:",
    ";inline-size:fit-content;padding-inline:",
    ";white-space:nowrap;",
    ""
], function(props) {
    return TypographyStyles({
        variant: "paragraphSansRegular",
        theme: props.theme
    });
}, function(props) {
    return props.$backgroundColor;
}, function(props) {
    return props.$border;
}, function(props) {
    var _props_$borderRadius;
    return (_props_$borderRadius = props.$borderRadius) !== null && _props_$borderRadius !== void 0 ? _props_$borderRadius : "4px";
}, function(props) {
    return props.$contentColor;
}, function(props) {
    return props.$border === "none" ? "8px" : "7px";
}, highVisSlateComponent(HIGH_VIS_FILTER.COMPONENT));
